import { logData, logError, logWarn } from './log.js';
import { jsonParse } from './parse.js';
import { isAndroid, isFabricWebview, isHarmony, isIphone } from './webview.js';

const webview = {
  isAndroid,
  isIphone,
  isHarmony,
  isFabricWebview,
};

const parse = {
  jsonParse,
};

const log = {
  logData,
  logError,
  logWarn,
};

export const utils = {
  log,
  parse,
  webview,
};
